import fetchExchangeRates from '#/repository/fetch-exchange-rates';
import {useQuery} from '@tanstack/react-query';

export const useExchangeRates = () =>
  useQuery({
    queryKey: ['exchange-rates'],
    queryFn: () => fetchExchangeRates(),
  });
